import template from './home.template.html';
import controller from './home.controller';
import './home.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/home/home.component.js